// ============================================================================
// SÉLECTEURS DOM - Éléments principaux du formulaire
// ============================================================================

const formSteps = document.querySelector('.form-steps');
const form = document.querySelector('.form');
const progress = document.querySelectorAll('.step');
const prevBtn = document.querySelectorAll('.back');
const nextBtn = document.querySelectorAll('.next');

// ============================================================================
// ÉTAT DE L'APPLICATION
// ============================================================================

let currentStep = 0;
let noUpsell = false;
let lastClickedButton = null;

// ============================================================================
// GESTION DE LA NAVIGATION ENTRE LES ÉTAPES
// ============================================================================

/**
 * Affiche l'étape spécifiée du formulaire et met à jour la barre de progression
 * @param {number} stepIndex - Index de l'étape à afficher
 */
function showStep(stepIndex) {
    const fieldsets = form.querySelectorAll('fieldset');
    
    // Retire la classe 'active' de toutes les étapes
    fieldsets.forEach((fieldset) => {
        fieldset.classList.remove('active');
    });
    
    // Active l'étape courante
    fieldsets[stepIndex].classList.add('active');
    updateProgressBar(stepIndex);
}

/**
 * Met à jour la barre de progression visuelle
 * @param {number} currentStep - Étape actuelle
 */
function updateProgressBar(currentStep) {
    progress.forEach((step, index) => {
        if (index <= currentStep) {
            step.classList.add('active');
        } else {
            step.classList.remove('active');
        }
    });
}

/**
 * Retourne à l'étape précédente
 */
function prevStep() {
    if (currentStep > 0) {
        currentStep--;
        showStep(currentStep);
    }
}

/**
 * Passe à l'étape suivante
 */
function nextStep() {
    if (currentStep < progress.length - 1) {
        currentStep++;
        showStep(currentStep);
    }
}

/**
 * Retourne à la page d'accueil (masque le formulaire)
 */
function backToHome() {
    formSteps.style.display = 'none';
}

// ============================================================================
// GESTION DES PARAMÈTRES URL
// ============================================================================

/**
 * Initialise le formulaire à partir des paramètres URL
 * Permet de pré-sélectionner une étape et des options via l'URL
 */
function fromURL() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const step = urlParams.get('step');
    const step1_option = urlParams.get('step1_option');
    const step2_option = urlParams.get('step2_option');

    // Charge l'étape depuis l'URL
    if (step != null) {
        currentStep = parseInt(step) - 1;
        document.querySelectorAll('.form_step').forEach((step) => {
            step.classList.remove('active');
        });
        document.querySelector('.form_step.step' + step).classList.add('active');
    }

    // Pré-sélectionne l'option de l'étape 1
    if (step1_option != null) {
        document.querySelectorAll('.form_step.step1 .option').forEach((option) => {
            option.classList.remove('active');
        });
        document.querySelectorAll('.form_step.step1 .option')[(step1_option - 1)].classList.add('active');
    }

    // Pré-sélectionne l'option de l'étape 2
    if (step2_option != null) {
        document.querySelectorAll('.form_step.step2 .option').forEach((option) => {
            option.classList.remove('active');
        });
        document.querySelectorAll('.form_step.step2 .option')[(step2_option - 1)].classList.add('active');
    }
}

// ============================================================================
// GESTION DES OPTIONS ET OFFRES
// ============================================================================

/**
 * Sélectionne une option dans une étape du formulaire
 * @param {HTMLElement} optionSelected - L'élément option sélectionné
 * @param {number} step_number - Numéro de l'étape
 */
function selectOption(optionSelected, step_number) {
    // Désactive toutes les options de l'étape
    document.querySelector('.form .step' + step_number)
        .querySelectorAll('.option')
        .forEach((option) => {
            option.classList.remove('active');
        });
    
    // Active l'option sélectionnée
    optionSelected.classList.add('active');
    
    // Met à jour l'affichage
    updateCurrentSelectedOffer();
    showBadge();
    showMention();
    showMentionText();
}

/**
 * Met à jour l'offre affichée en fonction des options sélectionnées
 * Combine les clés des deux étapes pour afficher l'offre correspondante
 */
function updateCurrentSelectedOffer() {
    const activeOptions = document.querySelectorAll('.form_step .option.active');
    const first_key = activeOptions[0].dataset.combinaisonKey;
    const second_key = activeOptions[1].dataset.combinaisonKey;
    const combinedKey = first_key + second_key;

    // Active l'offre correspondante à la combinaison
    document.querySelectorAll('.issue').forEach((issue) => {
        if (issue.dataset.combinaisonKey === combinedKey) {
            issue.classList.add('active');
        } else {
            issue.classList.remove('active');
        }
    });
}

/**
 * Récupère l'ID du variant de l'offre actuellement sélectionnée
 * @returns {number} ID du variant
 */
function getCurrentSelectedOfferID() {
    return parseInt(document.querySelector('.issue.active').dataset.variantId);
}

/**
 * Récupère l'ID du plan de vente de l'offre actuellement sélectionnée
 * @returns {number} ID du plan de vente
 */
function getCurrentSelectedOfferPlanID() {
    return parseInt(document.querySelector('.issue.active').dataset.sellingplanId);
}

// ============================================================================
// GESTION DES BADGES ET MENTIONS
// ============================================================================

/**
 * Affiche le badge correspondant à l'option sélectionnée à l'étape 1
 */
function showBadge() {
    const selectedKey = document.querySelector('.form .step1 .option.active').dataset.combinaisonKey;
    
    // Désactive tous les badges
    document.querySelectorAll('.option-badge, .popup-badge').forEach((badge) => {
        badge.classList.remove('active');
    });
    
    // Active les badges correspondants
    document.querySelector('.option-badge[data-condition="' + selectedKey + '"]').classList.add('active');
    document.querySelector('.popup-badge[data-condition="' + selectedKey + '"]').classList.add('active');
}

/**
 * Affiche le texte de mention correspondant à l'option sélectionnée
 */
function showMentionText() {
    const selectedKey = document.querySelector('.form .step1 .option.active').dataset.combinaisonKey;
    
    // Désactive toutes les mentions
    document.querySelectorAll('.option-mention').forEach((mention) => {
        mention.classList.remove('active');
    });
    
    // Active les mentions correspondantes
    document.querySelectorAll('.option-mention[data-condition="' + selectedKey + '"]').forEach((mention) => {
        mention.classList.add('active');
    });
}

/**
 * Affiche les mentions et titres dans la popup selon l'option sélectionnée
 */
function showMention() {
    const selectedKey = document.querySelector('.form .step1 .option.active').dataset.combinaisonKey;
    
    // Désactive toutes les mentions et titres
    document.querySelectorAll('.popup-mention').forEach((badge) => {
        badge.classList.remove('active');
    });
    document.querySelectorAll('.title-popup-titre').forEach((titre) => {
        titre.classList.remove('active');
    });
    document.querySelectorAll('.title-popup-description').forEach((titre) => {
        titre.classList.remove('active');
    });
    
    // Active les éléments correspondants
    document.querySelector('.popup-mention[data-condition="' + selectedKey + '"]').classList.add('active');
    document.querySelector('.title-popup-titre[data-condition="' + selectedKey + '"]').classList.add('active');
    document.querySelector('.title-popup-description[data-condition="' + selectedKey + '"]').classList.add('active')
}

// ============================================================================
// GESTION DE LA POPUP D'UPSELL
// ============================================================================

/**
 * Affiche la popup d'upsell
 */
function showPopup() {
    document.getElementById("form-popup").style.display = "flex";
}

/**
 * Ferme la popup d'upsell
 */
function closePopup() {
    document.getElementById("form-popup").style.display = "none";
}

/**
 * Sélectionne une offre depuis la popup et déclenche le checkout
 * @param {string} offer - Clé de combinaison de l'offre
 */
function takeOffer(offer) {
    console.log(offer);
    closePopup();
    
    // Sélectionne l'option correspondante à l'offre
    let offerEl = document.querySelector('.form_step.step2').querySelector('.option[data-combinaison-key="' + offer + '"]');
    if (offerEl) {
        offerEl.click();
    }

    // Déclenche le checkout après un court délai
    setTimeout(() => {
        lastClickedButton.click();
    }, 50);
}

// ============================================================================
// GESTION DU CHECKOUT SHOPIFY
// ============================================================================

/**
 * Effectue un checkout sans upsell
 * @param {boolean} redirect - Si true, redirige vers le checkout
 * @returns {Promise<Object|null>} Réponse de l'API ou null en cas d'erreur
 */
async function checkoutWithNoUpsell(redirect = true) {
    // Empêche les appels multiples
    if (noUpsell) return;
    
    noUpsell = true;
    
    const formData = {
        'items': [{
            'id': getCurrentSelectedOfferID(),
            'selling_plan': getCurrentSelectedOfferPlanID(),
            'quantity': 1
        }]
    };

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (redirect) {
            if (lastClickedButton) {
                lastClickedButton.click();
            } else {
                location.href = '/checkout';
            }
        }
        
        return await response.json();
    } catch (error) {
        console.error('Error:', error);
        return null;
    }
}

/**
 * Gère le clic sur le bouton de checkout avec vérification de popup
 * @param {Event} e - Événement du clic
 * @param {HTMLElement} button - Bouton cliqué
 */
function checkoutButton(e, button) {
    lastClickedButton = button;
    let alreadyTriggered = false;

    // ID de la popup à vérifier (codé en dur)
    const popup_id = '1mois';

    // Vérifie si la popup doit être affichée
    if (popup_id != null && !document.querySelector('.next-checkout').classList.contains('popupTriggered')) {
        document.querySelectorAll('.form_step').forEach((step) => {
            const activeOption = step.querySelector('.option.active');
            if (activeOption != null && activeOption.dataset.combinaisonKey === popup_id) {
                showPopup();
                alreadyTriggered = true;
                document.querySelector('.next-checkout').classList.add('popupTriggered');
                
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });
    }
}

/**
 * Effectue le checkout principal avec gestion de la popup d'upsell
 * @param {string|null} popup_id - ID de la popup à vérifier
 * @param {boolean} redirect - Si true, redirige vers le checkout
 */
function checkout(popup_id = null, redirect = true) {
    let popupTriggered = false;

    // Vérifie si une popup d'upsell doit être affichée
    if (popup_id != null && !document.querySelector('.next-checkout').classList.contains('popupTriggered')) {
        document.querySelectorAll('.form_step').forEach((step) => {
            const activeOption = step.querySelector('.option.active');
            if (activeOption != null && activeOption.dataset.combinaisonKey === popup_id) {
                showPopup();
                popupTriggered = true;
                document.querySelector('.next-checkout').classList.add('popupTriggered');
            }
        });
    }

    // Procède au checkout si aucune popup n'a été déclenchée
    if (!popupTriggered) {
        const formData = {
            'items': [{
                'id': getCurrentSelectedOfferID(),
                'selling_plan': getCurrentSelectedOfferPlanID(),
                'quantity': noUpsell ? 0 : 1
            }]
        };
        
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                if (redirect) {
                    location.href = '/checkout';
                }
                return response.json();
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
}

// Expose les fonctions de checkout globalement
window.checkoutFunctions = window.checkoutFunctions ? {
    ...window.checkoutFunctions,
    checkout: checkout,
    checkoutWithNoUpsell: checkoutWithNoUpsell,
} : {
    checkout: checkout,
    checkoutWithNoUpsell: checkoutWithNoUpsell,
};

// ============================================================================
// INITIALISATION DU FORMULAIRE
// ============================================================================

/**
 * Initialise le formulaire multi-étapes avec tous ses événements
 */
function initForm() {
    // Affiche la première étape
    showStep(currentStep);

    // Pré-sélectionne les options par défaut
    document.querySelector('.form .step1').querySelectorAll('.option')[0].classList.add('active');
    document.querySelector('.form .step2').querySelectorAll('.option')[1].classList.add('active');

    // Configure les boutons de navigation
    prevBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            prevStep();
        });
    });

    nextBtn.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            nextStep();
        });
    });

    // Met à jour l'affichage initial
    updateCurrentSelectedOffer();
    showBadge();
    showMention();
    showMentionText();
    fromURL();

    // Configure les événements de checkout avec popup
    let buttons = document.querySelectorAll('#juo-static-checkout-link, .next-checkout');
    buttons.forEach(value => {
        value.addEventListener('click', function(e) {
            checkoutButton(e, value);
        }, true);
    });

    // Configure les événements de checkout standard
    let buttonsCheckout = document.querySelectorAll('.next-checkout');
    buttonsCheckout.forEach(value => {
        value.addEventListener('click', function(e) {
            checkout('1mois');
        }, true);
    });
}

// Lance l'initialisation au chargement
initForm();